import ApiService from '/src/services/ApiService'
import SignatureScreen from '../../../../components/SignatureScreen.vue'
import { computed } from 'vue'

export default {
  components: {
    SignatureScreen,
  },

  created() {
    const serviceOrderData = sessionStorage.getItem('serviceOrder')
    if (serviceOrderData) {
      this.currentServiceOrder = JSON.parse(serviceOrderData)
    } else {
      this.$toast.error('Nenhuma ordem de serviço encontrada!')
      this.$router.push('/serviceorders')
    }
    this.getElectricalSafetyPattern()

    this.signImage = this.serviceOrder.arkMedsChecklist.executorImage || ''
    this.signImagePath = this.signImage

    this.user = JSON.parse(localStorage.getItem('user'))
  },

  data() {
    return {
      apiService: new ApiService(),
      requestDateTime: null,
      requestDateTimeError: false,
      attendDateTime: null,
      attendDateTimeError: false,
      checklistPattern: '',
      currentServiceOrder: {},
      departmentInactive: false,
      inputDisabled: false,
      isEditing: false,
      loading: false,
      pattern: null,
      patterns: [],
      signatureConfirmDialog: false,
      signImagePath: '',
      signImage: '',
      option: null,
      executorName: '',
      user: {},
    }
  },
  computed: {
    hasExecutorSignature() {
      const image = this.currentServiceOrder?.arkMedsChecklist?.executorImage
      return !!image && image.trim() !== ''
    },
  },

  methods: {
    sign(data) {
      if (this.option == 0) {
        if (this.user.signatureImage) {
          if (
            this.user.signatureImage.includes(
              'https://equipacarefix.blob.core.windows.net/'
            )
          ) {
            this.signImage = this.user.signatureImage
            this.signImagePath = this.user.signatureImage
          } else {
            this.signImage = `wwwroot/Uploads/Users/${this.user.id}/signatureImage`
            this.signImagePath = `${process.env.VUE_APP_BASE_URL}Uploads/Users/${this.user.id}/signatureImage/${this.user.signatureImage}`
          }

          this.signatureConfirmDialog = false
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique se existe uma assinatura cadastrada em seu usuário'
          )
        }
      } else {
        this.signImage = data
        this.signatureConfirmDialog = false
      }
    },
    setRequestNowDate() {
      if (!this.requestDateTime) {
        this.requestDateTime = moment().format('DD/MM/YYYY HH:mm')
      }
    },
    setAttendNowDate() {
      if (this.requestDateTime) {
        this.attendDateTime = moment().format('DD/MM/YYYY HH:mm')
      }
    },

    close() {
      this.$router.push('/serviceorders')
    },

    async getElectricalSafetyPattern() {
      try {
        const response = await this.apiService.get(
          `ElectricalSafetyPattern/list/${this.currentServiceOrder.institutionId}`
        )
        if (response) {
          this.patterns = response.content
        } else {
          console.warn('Nenhum padrão retornado ou formato inesperado')
        }
      } catch (error) {
        console.error('Erro ao carregar padrões:', error)
        this.$toast.error('Erro ao carregar padrões!')
      }
    },

    async linkChecklistToPattern() {
      if (!this.pattern) {
        this.$toast.error('Selecione um padrão antes de vincular!')
        return
      }

      try {
        const payload = {
          checklistId: this.currentServiceOrder.arkMedsChecklist.id,
          patternId: this.pattern,
          executorName: this.executorName,
          executingUserId: this.user.id,
          executorImage: this.signImage,
          isExecutingSigned: true,
        }

        const response = await this.apiService.post(
          'arkmeds/webhooks/link-pattern-to-checklist',
          payload
        )

        if (response.statusCode === 200) {
          this.$toast.success('Padrão vinculado com sucesso!')
          this.$router.push('/serviceorders')
        } else {
          this.$toast.error('Erro ao vincular o padrão ao checklist.')
        }
      } catch (error) {
        this.$toast.error('Erro ao vincular o padrão', error)
      }
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year, hour, minute] = date
        .split(/\D+/)
        .map((value) => parseInt(value, 10))

      return new Date(year, month - 1, day, hour, minute).toISOString()
    },

    submitForm() {
      this.linkChecklistToPattern()
    },
  },
}
